// extracted by mini-css-extract-plugin
export var cta = "ParagraphCountdownTimer-module--cta--aad29";
export var paragraphCountdownTimer = "ParagraphCountdownTimer-module--paragraphCountdownTimer--a6920";